module.exports = __webpack_public_path__ + "img/8-02.295e05b3.png";